import React, { Component } from "react";

class PageHeader extends Component {
  render() {
    const { title, description } = this.props;
    return (
      <div className="col-12 page-divider">
        <h3 className="m-0 p-2">{title}</h3>
        {description && <h5 className="m-0 px-2 pb-2">{description}</h5>}
      </div>
    );
  }
}

export default PageHeader;
